<template>
  <div class="h-680px">
    <Loading
      v-if="loading"
      class="h-full"
    />

    <UnitReview
      v-else
      :cards="reviewCards"
      @back="emit('done')"
    />
  </div>
  <div class="absolute z-2 h-44px top-0 right-0 flex items-center px-2">
    <Icon
      name="close"
      class="cursor-pointer w-20px"
      @click="emit('done')"
    ></Icon>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import UnitReview from '@/components/UnitReview.vue'
import Icon from '@/components/Icon.vue'
import { fetchAtlasStageCards, type AtlasStageCard } from '@/api/atlas'

const loading = ref(true)

const props = defineProps<{
  stageId: number
}>()

const emit = defineEmits<{
  done: []
}>()

const reviewCards = ref<AtlasStageCard[]>([])

fetchAtlasStageCards(props.stageId)
  .then(res => {
    reviewCards.value = res.cards
  })
  .finally(() => {
    loading.value = false
  })
</script>
<style scoped></style>
